import { getFontStyle } from '@diversioteam/diversio-ds'
import styled from 'styled-components'

export const ResultsSummaryCard = styled.div`
    justify-content: center;
    border-radius: 15px;
    max-width: 800px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-top: 24px;
    padding: 24px 30px;
    border-radius: 15px;
    max-height: 75px;
    border: 1.5px solid ${({ theme }) => theme.colors.secondary100Transparent};
    background: ${({ theme }) => theme.colors.primaryWhite};
`
export const SummaryTitle = styled.header`
    color: ${({ theme }) => theme.colors.primary90};
    text-align: center;
    ${getFontStyle('cardHeaderBold')}
`
export const SummaryTooltip = styled.div``
